import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { Typography } from "@mui/material";
import { DialogAlert } from "../Components/DialogAlert";
import { addEspaceCharacters, instance } from "../Components/config";
import { Link as RouterLink } from "react-router-dom";
import { LoaderBox } from "../Components/LoaderBox";

function RecuperarPassword() {
  const [dialog, setDialog] = React.useState({ title: "", text: "" });
  const [openDialog, setOpenDialog] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    setIsSubmitting(true);
    instance
      .post("/auth/recovery", {
        email: addEspaceCharacters(info.email.value),
      })
      .then(() => {
        setDialog({
          title: "Recuperación exitosa",
          text:
            "Se ha enviado un correo electrónico a " +
            info.email.value +
            " con el vínculo para poder recuperar tu cuenta.",
          redirect: true,
          page: "/Login",
        });
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message });
        }
      })
      .finally(() => {
        setIsSubmitting(false);
        setOpenDialog(true);
      });
  };
  return (
    <LoaderBox>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: { xs: "16px", sm: "24px" },
          marginTop: 8,
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 2,
            marginBottom: 2,
          }}
        >
          <Box
            component="img"
            src={require("../imgs/icta.png")}
            alt="Logo ICTA"
            sx={{ width: 96, height: "auto", mb: 1 }}
          />
          <Typography component="h1" variant="h5">
            Recuperar contraseña
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: "center" }}>
            Ingresa el correo electrónico de tu cuenta y te enviaremos un vínculo para restablecer tu contraseña.
          </Typography>
          <Box
            component="form"
            noValidate
            sx={{ mt: 2, width: "100%" }}
            onSubmit={handleSubmit}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Correo electrónico"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={isSubmitting}
              sx={{ mt: 2, mb: 1, py: 1.2 }}
            >
              {isSubmitting ? "Enviando..." : "Enviar correo para recuperar contraseña"}
            </Button>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
              <Link component={RouterLink} to="/Login">Volver a iniciar sesión</Link>
            </Box>
          </Box>
        </Box>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { RecuperarPassword };
